<filter-item-multiple [label]="'ui.filter_approval_status.label' | translate" icon="pi pi-shield" [selectedValues]="selected" [options]="options" (optionSelected)="handleSelected($event)"></filter-item-multiple>
